import { render } from "./Seo.vue?vue&type=template&id=9fb6b960&scoped=true"
import script from "./Seo.vue?vue&type=script&lang=js"
export * from "./Seo.vue?vue&type=script&lang=js"

import "./Seo.vue?vue&type=style&index=0&id=9fb6b960&scoped=true&lang=css"

import exportComponent from "D:\\my\\game-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fb6b960"]])

export default __exports__